export function createCtrl(option) {
  const { config, ...propty } = option;
  const ctrl = {
    id: 'ctrl-0',
    parentId: 'root', // 所在容器区块id
    type: 'Row', // 当前节点类型
    children: [],
    ...propty,
    config: {
      ...config
    }
  };
  return ctrl;
}

export function createGridNode(option) {
  const { ...propty } = option;
  const grid = {
    id: 'grid-0',
    parentId: 'root', // 所在容器区块id
    type: 'Grid', // 当前节点类型
    children: [],
    ...propty,
    config: {}
  };
  return grid;
}
